import { useAsync } from "react-async";
import { Grid, List } from "semantic-ui-react";
import { HeaderItem } from "../../common/components/HeaderItem";
import { MainHeader } from "../../common/components/MainHeader";
import { PlaceholderHeader } from "../../common/components/PlaceholderHeader";
import { Icons } from "../../common/Icons";
import { useAuth, userActiveView } from "../../utils/Auth";
import { useSettingValue } from "../../utils/Hooks";
import { AxiosPositionsAPI } from "../Api";
import "./PositionDetailHeader.css";

const PositionHeader = ({ position }) => {
  let startDate = position.current_record?.timespan.lower;
  let dateSubtitle =
    startDate && `Desde ${startDate.format()} (${startDate.fromNow()})`;
  const { user } = useAuth();
  const isSalaryRangeEnabled = useSettingValue(
    "T011_POSITION_SALARY_RANGE_ENABLE",
  );

  const formatSalary = (salary) =>
    salary != null
      ? `R$ ${Number(salary).toLocaleString("pt-BR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`
      : "-";

  return (
    <div>
      <MainHeader title={position.name} subtitle={dateSubtitle} />
      <Grid stackable style={{ marginTop: "0", marginBottom: "0" }}>
        <Grid.Row>
          <Grid.Column width={2}>
            <HeaderItem
              icon={Icons.CODE}
              label="Código"
              value={position.code}
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <HeaderItem
              icon={Icons.EMPLOYEE_COUNT}
              label="Funcionários"
              value={position.employee_count}
            />
          </Grid.Column>
          <Grid.Column width={2}>
            <HeaderItem
              icon={Icons.CATEGORY}
              label="Categoria"
              value={position.category}
            />
          </Grid.Column>
          <Grid.Column width={3}>
            <HeaderItem
              icon={Icons.SENIORITY_LEVEL}
              label="Nível de senioridade"
              value={position.seniority_level?.level ?? "-"}
            />
          </Grid.Column>
          {isSalaryRangeEnabled && userActiveView(user) && (
            <Grid.Column width={4}>
              <HeaderItem
                icon={Icons.SALARY_RANGE}
                label="Faixa de Remuneração"
                value={
                  position.min_salary
                    ? `${formatSalary(position.min_salary)} - ${formatSalary(
                        position.max_salary,
                      )}`
                    : "-"
                }
              />
            </Grid.Column>
          )}
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            <List>
              <List.Item>
                <List.Icon name={Icons.DESCRIPTION} />
                <List.Content>
                  <List.Description>
                    <span className="position-description">
                      {position.description || "-"}
                    </span>
                  </List.Description>
                </List.Content>
              </List.Item>
            </List>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export const PositionDetailHeader = ({ position_id }) => {
  const { isPending, data, error } = useAsync({
    promiseFn: AxiosPositionsAPI.getById,
    position_id: position_id,
  });

  if (isPending) return <PlaceholderHeader />;
  if (error) return <MainHeader title="(Cargo desconhecido)" />;
  if (data) return <PositionHeader position={data} />;

  return null;
};
